export default __webpack_public_path__ + "static/media/include_16@2x.f872bd63.jpg";